import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import MoneyView from 'shared/components/MoneyView';
import { StockPositionDetailsSellFragment } from './__generated__/StockPositionDetailsSellFragment';
import Fees from '../Fees';
import { TransactionInfo } from 'components/PositionDetailsModal/components/TransactionInfo';
import { DateTime } from 'components/PositionDetailsModal/components/DateTime';
import NumberView from 'shared/components/NumberView';

import './styles.scss';

interface Props {
  transaction: StockPositionDetailsSellFragment;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('stock-position-details-sell');

const enhance = compose<Enhanced, Props>(translate);

function Sell({ t, transaction }: Enhanced) {
  if (!transaction || !transaction.quantity) {
    return null;
  }

  const { quantity, price, netAmount, amount, createdAt } = transaction;

  return (
    <TransactionInfo
      title={t('Selling')}
      items={[
        <NumberView>{quantity}</NumberView>,
        <MoneyView cents>{price}</MoneyView>,
        <MoneyView cents>{amount}</MoneyView>,
        <Fees transaction={transaction} />,
        <MoneyView cents sign className={b('amount')}>
          {netAmount}
        </MoneyView>,
        <DateTime>{createdAt}</DateTime>,
      ]}
    />
  );
}

export default enhance(Sell);
